import {Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, PaymentCard, Types} from "@falcon/services";
import * as React from "react";
import {Checkbox} from "../../../../../components/inputs/Checkbox";

interface IProps {
    reuseCard?: boolean
    mainPaymentCard?: PaymentCard,
    policyNumber?: string,
    handleReuseCardChange?: (reuseValue: boolean) => void
}

interface IState {
    showOverlay: boolean,
    reuseCard?: boolean
}

export class CardReuseCheckbox extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            showOverlay: false,
            reuseCard: this.props.reuseCard
        }

        this.onCardStorageConsentChange = this.onCardStorageConsentChange.bind(this);
    }

    public render(): JSX.Element {
        return <>
            <div className="card-reuse-checkbox grid-col-2">
                <Checkbox
                    className="mt-3 ml-3"
                    label="I consent to my card details being stored securely for any future policy changes I make."
                    name="cardStorageConsentCheckbox"
                    id="cardStorageConsentCheckbox"
                    value={this.state.reuseCard!}
                    onChanged={this.onCardStorageConsentChange}
                />
            </div>
            <Overlay show={this.state.showOverlay} />
        </>
    }

    private onCardStorageConsentChange(value: boolean) {
        this.setState({showOverlay: true})

        if (this.props.policyNumber) {
            this.customerPortalService
                .changeCardReuseSetting(this.props.mainPaymentCard!.id, value, this.props.policyNumber)
                .subscribe(() => {
                    this.setState({showOverlay: false, reuseCard: !this.state.reuseCard});
                });
        } else {
            this.customerPortalService
                .changeCardReuseSetting(this.props.mainPaymentCard!.id, value)
                .subscribe(() => {
                    this.setState({showOverlay: false, reuseCard: !this.state.reuseCard});
                });
        }
        if(this.props.handleReuseCardChange){
            this.props.handleReuseCardChange(!this.state.reuseCard) ;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/CardReuseCheckbox.tsx